export const GET_RESTAURANT_CATEGORY_SLIDER = "GET_RESTAURANT_CATEGORY_SLIDER";
